var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('checkout-header',{attrs:{"title":_vm._f("t")('Login'),"logo":_vm.headerBlock.logo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }